import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { getProfileAction } from 'store/profile/actions'
import { BreakpointsProvider, classnames } from '@centra/centra-ui'
import styled from './Header.module.scss'

interface IHeader {
  fixedHeader: boolean
}

const ToplineRemote = await import('tasktracker/Topline')
  .then(res => res)
  .catch(() => ({ default: { Topline: () => null } }))
const ToplineComponent = ToplineRemote.default.Topline

const Header = (props: IHeader) => {
  const { fixedHeader } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const { user, profile } = useSelector(
    ({ auth, profile }) => ({
      user: auth.user,
      profile: profile.profile,
    }),
    shallowEqual
  )

  useEffect(() => {
    if (!profile) dispatch(getProfileAction())
  }, [profile])

  const classes = classnames(styled.root, {
    [styled.rootFixed]: fixedHeader,
  })

  if (!user) return null

  return (
    <div className={classes}>
      <BreakpointsProvider formFactor="DESKTOP">
        <ToplineComponent push={history.push} isStaticMenu={!fixedHeader} theme="white" />
      </BreakpointsProvider>
    </div>
  )
}

export default Header
